import styled, { css } from "styled-components";

export const PresetsStyled = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
`;

export const Button = styled.button`
    z-index: 1;

    width: ${({ width }) => width || "20%"};

    padding: 10px;

    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;

    background-color: var(--color-white);

    border: 1px solid rgba(0, 23, 75, 0.1);

    transition: 0.2s background ease-in-out;

    :not(:last-of-type) {
        margin-right: 10px;
    }

    :hover,
    :active {
        color: var(--color-white);

        background: var(--color-peach);
        box-shadow: 2px 2px 0 0 rgba(180, 120, 255, 1);
    }

    ${({ active }) =>
        active &&
        css`
            color: var(--color-white);

            background: var(--color-peach);
            box-shadow: 2px 2px 0 0 rgba(180, 120, 255, 1);
        `}
`;
